import React from 'react'
import classes from './Version.module.scss'
import versionFile from '../../config/version.json'

const Version = () => {
  return (
    <div className={classes.root}>
      {versionFile.version}
    </div>
  )
}

export default Version
